export default __webpack_public_path__ + "static/media/pp-6.87f48150.svg";